/**
 * @deprecated please use @website/ui instead
 */
export const useLoading = () => ({
  rootProps: {
    role: "alert"
  }
});
